import { render, staticRenderFns } from "./UserCardEdit.vue?vue&type=template&id=ec303a1a&"
import script from "./UserCardEdit.vue?vue&type=script&lang=js&"
export * from "./UserCardEdit.vue?vue&type=script&lang=js&"
import style0 from "./UserCardEdit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VHover } from 'vuetify/lib/components/VHover';
installComponents(component, {VAvatar,VCard,VCardText,VDivider,VHover})
